import get from 'lodash/get';
import axios from 'axios';
import { modalSteps } from '.';

export const errorReasons = {
  AGE: 'Age',
  MIN_AGE: 'MinAge',
  EXPIRED: 'Expired',
  PIN: 'Pin',
  RIGHTS: 'Rights',
  DECLINED: 'Declined',
  INVALID_DOCUMENT: 'InvalidDocument',
  OTHER: 'Other',
};

export const getAccountId = () => get(window.merchantos, 'account.id');

export const getEmployeeId = () => {
  const getEmployee = get(window.merchantos, 'session.getEmployee');
  return (getEmployee && getEmployee().employeeID) || 0;
};

export const getSaleId = () =>
  get(document.getElementById('register'), 'attributes.transaction_id.value');

export const getShopId = () => {
  const getShop = get(window.merchantos, 'session.getShop');
  return (getShop && getShop().shopID) || 0;
};

export const getRegisterId = () => {
  const getRegister = get(window.merchantos, 'session.getRegister');
  return (getRegister && getRegister().registerID) || 0;
};

export const parseCS4070Barcode = barcode =>
  barcode.replace(/Control([j6m]+)/g, (match, code) =>
    code
      .replace('j', String.fromCharCode('0010'))
      .replace('6', String.fromCharCode('0030'))
      .replace('m', String.fromCharCode('0013'))
  );

export const parseDS22Barcode = barcode => {
  const getMatchedStringFromCharcode = (_match, code) => String.fromCharCode(code);
  return barcode
    .replace(/Clear(\d{4})Clear/g, getMatchedStringFromCharcode)
    .replace(/NumLock(\d{4})NumLock/g, getMatchedStringFromCharcode);
};

export const DOCUMENT_TYPES = {
  DRIVERS_LICENSE: 'DriversLicense',
  IDENTIFICATION_CARD: 'IdentificationCard',
  PASSPORT: 'Passport',
  MILITARY: 'Military',
  CITIZENSHIP: 'Citizenship',
  ABORIGINAL: 'Aboriginal',
};

const errorReasonsMapping = {
  ExpiredDocument: errorReasons.EXPIRED,
  InvalidPIN: errorReasons.PIN,
  InsufficientManagerRights: errorReasons.RIGHTS,
};

export const sendAgeVerificationRequest = async ({
  reject,
  resolve,
  stepData,
  setStepWithData,
}) => {
  const saleId = getSaleId();
  const accountId = getAccountId();
  if (!saleId || !accountId) {
    // This flow shouldn't happen but in case some information is missing,
    // the API request will not be performed correctly
    reject();
  }

  try {
    const { documentType, dateOfBirth, cardExpiry, identificationHash, overridePIN } = stepData;
    await axios({
      method: 'post',
      url: `/API/Account/${accountId}/Sale/${saleId}/AgeVerification.json`,
      data: {
        documentType: DOCUMENT_TYPES[documentType] || documentType,
        dateOfBirth,
        cardExpiry,
        identificationHash,
        overridePIN,
      },
    });
    resolve();
  } catch ({ response, ...rest }) {
    const { message, errorClass } = get(response, 'data', { message: rest.message });
    const reason = errorReasonsMapping[errorClass] || errorReasons.OTHER;

    setStepWithData({
      step: modalSteps.AGE_VERIFICATION_ERROR,
      data: {
        reason,
        message,
        form: stepData,
      },
    });
  }
};
